;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import FavoriteButton from 'components/globals/FavoriteButton';

import Img from 'components/ui/Img';
import Link from 'components/ui/Link';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import { formatRecipeTime } from 'utils';

import styles from './CardRecipeGrid.module.scss';

const CardRecipeGrid = ({
    id,
    image,
    images,
    category,
    cookTime,
    prepTime,
    slug,
    title,
    attributes,
    recipesConfig,
    mealTypeLabels,
}) => {
    category ??= { title: '' };
    cookTime ??= 0;
    prepTime ??= 0;

    const attributesSorted = attributes?.meal?.sort((a, b) => a - b);
    const mealAttributes = recipesConfig?.meal.options;

    const mealTypes = attributesSorted
        ?.map(attr => {
            const match = mealAttributes?.filter(filter => {
                return filter.id === parseInt(attr, 10);
            });
            return match?.[0]?.label || false;
        })
        .filter(item => item !== false);

    const asset = images?.length > 0 ? images[0] : image;

    return (
        <article className={styles.root}>
            <div className={styles.favoriteButtonContainer}>
                <FavoriteButton itemType={'recipe'} itemId={id} />
            </div>
            <Link href={`/recipes/${slug}`} className={styles.inner}>
                <figure className={styles.aspectBox}>
                    {asset?.url && (
                        <Img
                            className={styles.image}
                            src={asset.url}
                            alt={asset.description || ''}
                            width={asset.width}
                            height={asset.height}
                            customSources={[
                                {
                                    breakpoint: 1440,
                                    src: asset.url,
                                    imageWidth: 1440 * 0.5,
                                },
                                {
                                    breakpoint: 1024,
                                    src: asset.url,
                                    imageWidth: 1024 * 0.5,
                                },
                                {
                                    breakpoint: 768,
                                    src: asset.url,
                                    imageWidth: 768 * 0.75,
                                },
                                {
                                    src: asset.url,
                                    imageWidth: 768,
                                },
                            ]}
                        />
                    )}
                </figure>
                <div className={styles.infoWrapper}>
                    <div className={styles.categoryWrapper}>
                        <Text
                            className={styles.category}
                            baseTheme="labelMedium"
                        >
                            {mealTypes?.[0] ||
                                mealTypeLabels?.[0] ||
                                category?.title}
                        </Text>
                        <div className={styles.infoLockup}>
                            <SvgIcon className={styles.timeIcon} type="clock" />
                            <Text
                                className={styles.timeLabel}
                                baseTheme="labelMedium"
                            >
                                {formatRecipeTime(prepTime + cookTime)}
                            </Text>
                        </div>
                    </div>
                    <Text
                        className={styles.headline}
                        baseTheme="headingSmall"
                        as="h5"
                    >
                        {title}
                    </Text>
                </div>
            </Link>
        </article>
    );
};

CardRecipeGrid.propTypes = {
    attributes: PropTypes.shape({
        meal: PropTypes.array,
    }),
    category: PropTypes.shape({
        title: PropTypes.string,
    }),
    cookTime: PropTypes.number,
    image: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    images: PropTypes.array,
    prepTime: PropTypes.number,
    recipesConfig: PropTypes.object,
    mealTypeLabels: PropTypes.array,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string,
};

export default CardRecipeGrid;
